import { APP_DEFAULT_ADULTS, APP_DEFAULT_CHILDREN } from '@common/constants/defaultParty';
import { RoomSettings } from '@common/features/roomSettings/types';
import { MultiRoomSearch } from 'shared-types';

export const updateRoomsAfterCountChange = (
  rooms: MultiRoomSearch,
  defaultParty?: RoomSettings['defaultParty'],
  roomIndexToDelete?: number
) => {
  let updatedAdults = rooms.reduce((acc, r) => (acc += r.adults), 0);
  let updatedChildren = rooms.reduce((acc, r) => (acc += r.children), 0);
  let updatedRooms = [...(rooms || [])];
  if (!roomIndexToDelete) {
    updatedAdults += defaultParty?.adults || APP_DEFAULT_ADULTS;
    updatedChildren += defaultParty?.children || APP_DEFAULT_CHILDREN;
    updatedRooms.push({
      roomNumber: (rooms?.length || 0) + 1,
      adults: defaultParty?.adults || APP_DEFAULT_ADULTS,
      children: defaultParty?.children || APP_DEFAULT_CHILDREN,
    });
  } else {
    const roomToDelete = (rooms || [])[roomIndexToDelete];
    if (roomToDelete) {
      updatedAdults = Math.max(0, updatedAdults - roomToDelete.adults);
      updatedChildren = Math.max(0, updatedChildren - roomToDelete.children);
      const roomsBeforeRemovedItem = rooms.slice(undefined, roomIndexToDelete);
      const roomsAfterRemovedItem = rooms
        .slice(roomIndexToDelete + 1)
        .map((r) => ({ ...r, roomNumber: r.roomNumber - 1 }));
      updatedRooms = [...roomsBeforeRemovedItem, ...roomsAfterRemovedItem];
    }
  }
  return { updatedRooms, updatedAdults, updatedChildren };
};
